module.exports = __webpack_public_path__ + "img/nelvys-campos-head-dental-assistant.d92c6418.jpg";